/** QR-Code als SVG-Markup (Bibliothek wird erst bei Bedarf geladen) */
export async function qrSvg(text: string, opts: { size?: number; dark?: string; light?: string } = {}): Promise<string> {
  const QRCode = await import('qrcode');
  return QRCode.toString(text, {
    type: 'svg',
    errorCorrectionLevel: 'M',
    margin: 1,
    width: opts.size ?? 240,
    color: { dark: opts.dark ?? '#000000', light: opts.light ?? '#ffffff' },
  });
}

export function svgDataUrl(svg: string): string {
  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
}
